import React from "react";
import { Container, Alert } from "react-bootstrap";

export interface IErrorProps {
    message? : string | undefined;
}

export const Error = ({message} : IErrorProps) => {

  if (!message) {
      message = "There has been a problem with your request";
  }

  return (
    <Container aria-atomic="true">
      <Alert variant="danger" className="margin-medium">
        {message}
      </Alert>
    </Container>
  );

}
